import { atomWithDefault } from 'jotai/utils';
import { atomFamily } from 'jotai-family';

import { IProviderFieldsDataModel } from '../../data-models/provider-fields.data-model';
import { getProviderFields } from '../queries/MappingsQueries';

/**
 * Per-company provider field mappings. Sentinel guard returns null for
 * invalid `companyId` (undefined / null / non-finite / <= 0) so a default
 * `-1` from `selectedCompanyIdProfileAtom` doesn't trigger a fetch.
 */
export const fieldsMappingByCompanyState = atomFamily((companyId: number) =>
  atomWithDefault<
    IProviderFieldsDataModel<unknown>[] | null | Promise<IProviderFieldsDataModel<unknown>[] | null>
  >(async () => {
    if (!companyId || !Number.isFinite(companyId) || companyId <= 0) {
      return null;
    }
    try {
      return await getProviderFields<unknown>(companyId);
    } catch (error) {
      console.error('Error fetching provider fields for companyId:', companyId, error);
      return null;
    }
  })
);
